import { useAppSelector } from "app/hooks";
import { RecentMatches } from "components/Matches/RecentMatches";
import { ShowMoreButton } from "components/Matches/styles";
import { Panel } from "components/Panel/Panel";
import { SingleColumnPage } from "pages/PageTemplates";
import { useState } from "react";
import { selectRecentMatchesPage } from "selectors/Match";
import { EmptyGrowPanelText } from "styles/text";

const RECENT_MATCHES_AMOUNT = 50;

export const MatchesPage = () => {
  const [currentAmount, setCurrentAmount] = useState<number | undefined>(
    RECENT_MATCHES_AMOUNT
  );

  const { matches: recentMatches, totalAmount } = useAppSelector((state) =>
    selectRecentMatchesPage(state, currentAmount)
  );

  if (recentMatches.length === 0) {
    return (
      <Panel>
        <EmptyGrowPanelText>
          No Matches For The Selected Filters
        </EmptyGrowPanelText>
      </Panel>
    );
  }

  return (
    <SingleColumnPage>
      <RecentMatches matches={recentMatches} showTrackScores={true} />
      {!!currentAmount && totalAmount > currentAmount && (
        <ShowMoreButton
          onClick={() => {
            if (!!currentAmount) {
              setCurrentAmount(currentAmount + RECENT_MATCHES_AMOUNT!);
            }
          }}
        >
          Show More
        </ShowMoreButton>
      )}
    </SingleColumnPage>
  );
};
